import { useCallback, RefObject } from 'react';

interface UseCoordinateConversionProps {
  scale: number;
  pageHeight: number;
  canvasRef: RefObject<HTMLDivElement | null>;
}

export const useCoordinateConversion = ({ scale, pageHeight, canvasRef }: UseCoordinateConversionProps) => {
  const screenToPDF = useCallback((screenX: number, screenY: number) => {
    if (!canvasRef.current) return { x: 0, y: 0 };
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (screenX - rect.left) / scale;
    const y = pageHeight - ((screenY - rect.top) / scale);
    return { x, y };
  }, [scale, pageHeight, canvasRef]);

  const pdfToScreen = useCallback((pdfX: number, pdfY: number, height: number) => {
    const screenX = pdfX * scale;
    const screenY = (pageHeight - pdfY - height) * scale;
    return { x: screenX, y: screenY };
  }, [scale, pageHeight]);

  return { screenToPDF, pdfToScreen };
};
